import './useCaseOptionField.scss'
import { useEffect, useState } from "react";
import SelectInput from "../../../../../components/shared/selectInput/selectInput";
import { SelectInputProps, Option } from "../../../../../components/shared/selectInput/types/selectInputProps";
import { UseCaseOptionFieldProps } from "./types/UseCaseOptionFieldProps";
import { ReactComponent as Close } from "../../../../../icons/close.svg";
import { PortalGroup } from '../../../../../contexts/permissionsContext';

const UseCaseOptionField = (props: UseCaseOptionFieldProps) => {
    const [rolesSelectOptions, setRolesSelectOptions] = useState<Option[]>([]);
    const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);
    const [definitions, setDefinitions] = useState<PortalGroup[]>(props.useCaseDefinitions.portalGroups);

    useEffect(() => {
        getAvailableRolesSelectOptions();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [definitions, selectedOptions]);
    
    // Role select
    const getSelectProps = (onChange: Function, options: Option[], selectedOptions: Option[]): SelectInputProps => {
        return {
            hasInputTags: true,
            options: options,
            onlySingleTag: false,
            onChange: onChange,
            pristine: true,
            placeHolder: "Wybierz rolę",
            selectedOptions: selectedOptions,
        }
    }

    const onChangeSelectOption = (opt: Option[]) => {
        var newArray = Object.assign([], opt);
        setSelectedOptions(newArray);

        var newArrayAsObjects = convertOptionsToPortalGroups(opt);
        var newObject = props.newUseCasesDefinitions;
        var idx = newObject.findIndex(item => item.useCase.id === props.useCaseDefinitions.useCase.id); 
        newObject[idx].portalGroups = [...definitions, ...newArrayAsObjects];
        props.setNewUseCasesDefinitions(newObject);
    }

    const convertOptionsToPortalGroups = (opt: Option[]) => {
        var portalGroups: PortalGroup[] = [];
        opt.forEach(item => portalGroups.push({ id: item.value as number, nazwa: item.name! }));
        return portalGroups;
    }

    const getAvailableRolesSelectOptions = () => {
        setRolesSelectOptions(props.rolesSelectOptions?.filter(item => 
            !definitions.some(elem => elem.id === item.value) && !selectedOptions.some(elem => elem.value === item.value)));
    }

    // Definitions
    const handleRemoveDefinition = (definitionId: any) => {
        var newArray = definitions.filter(item => item.id !== definitionId);
        setDefinitions(newArray);

        var selectedOptionsAsObjects = convertOptionsToPortalGroups(selectedOptions);
        var newObject = props.newUseCasesDefinitions;
        var idx = newObject.findIndex(item => item.useCase.id === props.useCaseDefinitions.useCase.id); 
        newObject[idx].portalGroups = [...newArray, ...selectedOptionsAsObjects];
        props.setNewUseCasesDefinitions(newObject);
    }
    
    return (
        <div className="useCaseOptionFieldWrapper">
            <div style={{width: "50%"}}>
                <h5 className='body-txt-medium'>{`${props.useCaseDefinitions.useCase?.koD_PU}: ${props.useCaseDefinitions.useCase?.nazwA_PU}`}</h5>
            </div>
            <div style={{width: "40%"}}>
                <SelectInput {...getSelectProps(onChangeSelectOption, rolesSelectOptions, selectedOptions)}/>
                <div className='currentDefinitions'>
                    {definitions?.map(item => {
                        return (<div key={item.id} className="brown-tag single-tag definitionTag">
                            <Close onClick={() => { handleRemoveDefinition(item.id) }} />
                            <span style={{ paddingRight: "5px" }}>{item.nazwa}</span>
                        </div>)
                    })}
                </div>
            </div>
        </div>
    )
}

export default UseCaseOptionField;